<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ data.title }}</h5>
  <button
    type="button"
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>

  <!-- Introductory paragraphs -->
  @if (data.paragraphs?.length || data.introNote) {

    <div class="mb-3">

      @for (
        paragraph of data.paragraphs ?? [];
        track $index;
        let last = $last
        ) {
        <p
          [class.mb-2]="!last || !!data.introNote"
          [class.mb-0]="last && !data.introNote">
          {{ paragraph }}
        </p>
      }

      <!-- Optional introductory note -->
      @if (data.introNote) {
        <p class="small text-muted mb-0">
          {{ data.introNote }}
        </p>
      }

    </div>

  }

  <!-- Information items -->
  @for (item of data.items ?? []; track item.id; let last = $last) {

    <div class="legend-row mb-3 pb-3" [class.border-bottom]="!last">

      <!-- Icon and labels -->
      <div class="d-flex align-items-center mb-2">

        @if (item.icon) {
          <mat-icon
            class="mr-1"
            aria-hidden="true"
            [color]="item.color"
            [style.color]="item.iconColor"
            [ngClass]="item.iconClass"
            [class.info-icon-neutral]="
              !item.color &&
              !item.iconColor &&
              !item.iconClass
            ">
            {{ item.icon }}
          </mat-icon>
        }

        <div class="d-flex flex-column">

          <span class="info-label">
            {{ item.label }}
          </span>

          @if (item.subLabel) {
            <span
              class="info-sub-label"
              [ngClass]="item.subLabelClass">
              {{ item.subLabel }}
            </span>
          }

        </div>

      </div>

      <!-- Optional description -->
      @if (item.description) {
        <div class="small mb-2">
          {{ item.description }}
        </div>
      }

      <!-- Optional labelled details -->
      @if (item.details?.length) {
        <div class="small">
          @for (
            detail of item.details ?? [];
            track $index;
            let last = $last
            ) {
            <div [class.mb-1]="!last">
              <span class="font-weight-bold">
                {{ detail.label }}:
              </span>
              {{ detail.value }}
            </div>
          }
        </div>
      }

    </div>

  }

  <!-- Optional information alert -->
  @if (data.alert; as alert) {
    <div
      class="alert mb-0"
      [ngClass]="'alert-' + alert.type"
      role="alert">
      @if (alert.icon !== null) {
        <mat-icon class="align-middle mr-2">
          {{ alert.icon || 'info' }}
        </mat-icon>
      }
      <small>{{ alert.message }}</small>
    </div>
  }

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button
      type="button"
      mat-raised-button
      mat-dialog-close>
      {{ data.closeLabel || 'Close' }}
    </button>
  </div>
</mat-dialog-actions>
